export default "__VITE_ASSET__CXbz6E6g__"